import { Block } from "app/shared/components/blocks/block";
import { spacing } from "app/shared/styles/spacing";
import { useMobileMediaQuery } from "app/shared/util/media-query";
import * as React from "react";
import { useTranslation } from "react-i18next";
import { View, StyleSheet, TextInput as NativeTextInput, Platform } from "react-native";
import { IconButton, useTheme } from "react-native-paper";
interface HistorySearchProps {
  onChangeTextInput: (text: string) => void;
  isShow?: boolean;
}

const HistoryTableSearch = (props: HistorySearchProps) => {
  const { onChangeTextInput, isShow = false } = props;
  const { fonts } = useTheme();
  const { t } = useTranslation();
  const isMobile = useMobileMediaQuery();

  const [txtSearch, setTxtSearch] = React.useState("");
  const txtInputRef = React.useRef<NativeTextInput>(null);

  //Search icon
  const searchIcon = <IconButton icon="table-search" size={24} />;

  // Clear Icon
  const clearText = () => {
    txtInputRef.current?.focus();
    setTxtSearch("");
    onChangeTextInput("");
  };
  const clear = <IconButton onPress={clearText} icon="close" size={24} />;

  // Styles
  const noOutline: any = Platform.OS === "web" && { outlineStyle: "none" };
  const shadow =
    txtSearch.length > 0
      ? {
          shadowColor: "#000",
          shadowOffset: {
            width: 0,
            height: 6,
          },
          shadowOpacity: 0.37,
          shadowRadius: 7.49,
          elevation: 12,
        }
      : {};
  const styles = React.useMemo(
    () =>
      StyleSheet.create({
        container: {
          position: "relative",
          backgroundColor: "transparent",
          height: 42,
          marginVertical: spacing.medium,
          width: "100%",
          display: isShow ? "flex" : "none",
        },
        animatedContainer: {
          marginLeft: isMobile ? 0 : "auto",
        },
        searchInput: {
          borderRadius: 24,
          height: 42,
          paddingLeft: 42,
          paddingRight: 42,
          ...fonts.medium,
          backgroundColor: txtSearch.length > 0 ? "white" : "rgba(151, 151, 151, 0.53)",
        },
        inputSearchIcon: {
          position: "absolute",
          left: 0,
          flex: 1,
          justifyContent: "center",
          alignItems: "center",
          width: 42,
          height: 42,
        },
        inputClose: {
          position: "absolute",
          right: 0,
          flex: 1,
          height: 42,
          justifyContent: "center",
          alignItems: "center",
        },
      }),
    [isMobile, isShow, fonts.medium, txtSearch.length],
  );
  return (
    <Block row spaced center>
      <View style={styles.container}>
        <View style={[styles.animatedContainer]}>
          <View style={[styles.inputSearchIcon]}>{searchIcon}</View>
          <NativeTextInput
            value={txtSearch}
            ref={txtInputRef}
            clearButtonMode="always"
            placeholder={t("COMMON_TIM_KIEM")}
            onChangeText={(text) => {
              setTxtSearch(text);
              onChangeTextInput(text);
              if (text.length === 0) {
                onChangeTextInput("");
              }
            }}
            style={[styles.searchInput, noOutline, shadow]}
          />
          <View style={[styles.inputClose]}>{clear}</View>
        </View>
      </View>
    </Block>
  );
};

export default HistoryTableSearch;
